<div data-testid="trial-funnel" class="trial-funnel">
  <div class="trial-funnel__header">
    <div class="trial-funnel__titles">
      <h4 class="trial-funnel__title">Trial funnel</h4>
      <p data-testid="trial-funnel-subtitle" class="trial-funnel__subtitle">{{ subtitle }}</p>
    </div>
  </div>
  <ng-container *ngIf="funnel && funnel.started > 0; else empty">
    <div #stageChart data-testid="trial-funnel-chart" class="trial-funnel__chart"
         role="img" aria-label="Trial funnel: started, active, converted"></div>
    <div class="trial-funnel__figures">
      <div class="trial-funnel__figure">
        <span class="trial-funnel__figure-label">Started → converted</span>
        <span data-testid="funnel-rate" class="trial-funnel__figure-value">{{ conversionRate | percent:'1.0-0' }}</span>
      </div>
      <div class="trial-funnel__figure">
        <span class="trial-funnel__figure-label">Median days to convert</span>
        <span data-testid="funnel-median" class="trial-funnel__figure-value">{{ funnel.medianDaysToConvert ?? '–' }}</span>
      </div>
    </div>
    <p class="trial-funnel__trend-label">Conversion rate by month</p>
    <div #trendChart data-testid="trial-funnel-trend" class="trial-funnel__trend"></div>
  </ng-container>
  <ng-template #empty>
    <app-admin-dashboard-empty *ngIf="failed" data-testid="trial-funnel-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
    <app-admin-dashboard-empty *ngIf="loaded && !failed" data-testid="trial-funnel-empty" icon="fa-regular fa-filter"
                               title="No trials started in this window"></app-admin-dashboard-empty>
  </ng-template>
</div>
